import { marked } from "marked";
import DOMPurify from "dompurify";

/**
 * Markdown → sanitisiertes HTML für die Chat-Darstellung.
 *
 * `marked` deckt CommonMark + GFM ab (Überschriften, fett/kursiv/durch, Inline-/
 * Block-Code, Links, verschachtelte Listen, Blockquotes, Tabellen, HR, Task-Lists).
 * `DOMPurify` entfernt anschließend potenziell gefährliches HTML/JS aus dem
 * Ergebnis — Pflicht, da Inhalte aus LLM/RAG-Quellen stammen.
 */
marked.setOptions({
  gfm: true,
  breaks: true, // einzelne Zeilenumbrüche → <br> (LLM-Ausgaben nutzen oft Single-Newlines)
});

// Links immer sicher in neuem Tab öffnen.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function renderMarkdown(md: string): string {
  const raw = marked.parse(md ?? "", { async: false }) as string;
  return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
}
